const COMMON_EVENT_NAMES = {
  OBJECT_CLICKED: 'Object Element Clicked',
  FORM_SUBMITTED: 'Form Submitted',
};

const tceCalculatorEventProps = {
  domain: 'tce-calculator',
};

export const tceCalculatorEvents = {
  FORM_SUBMITTED: {
    name: COMMON_EVENT_NAMES.FORM_SUBMITTED,
    eventProps: tceCalculatorEventProps,
  },
  ELEMENT_CLICKED: {
    name: COMMON_EVENT_NAMES.OBJECT_CLICKED,
    eventProps: tceCalculatorEventProps,
  },
};
